import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/i18n";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Installer from "@/pages/Installer";
import Activity from "@/pages/Activity";
import AgentScript from "@/pages/AgentScript";
import TvMatch from "@/pages/TvMatch";
import Inventory from "@/pages/Inventory";
import Scanners from "@/pages/Scanners";
import DeviceScan from "@/pages/DeviceScan";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Tickets from "@/pages/Tickets";
import Users from "@/pages/Users";
import Products from "@/pages/Products";
import Duplicates from "@/pages/Duplicates";
import Reports from "@/pages/Reports";
import Portal from "@/pages/Portal";
import SecurityPortal from "@/pages/SecurityPortal";
import EntwurfA from "@/pages/EntwurfA";
import StyleGuide from "@/pages/StyleGuide";
import EntwurfB from "@/pages/EntwurfB";
import EntwurfC from "@/pages/EntwurfC";
import Kontakt from "@/pages/Kontakt";
import Produkte from "@/pages/Produkte";
import Loesungen from "@/pages/Loesungen";
import Branchen from "@/pages/Branchen";
import Ressourcen from "@/pages/Ressourcen";
import Preise from "@/pages/Preise";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500 font-mono text-sm">
        Lädt…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <ConfirmProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/portal" element={<Portal />} />
              <Route path="/security-portal" element={<SecurityPortal />} />
              <Route path="/" element={<EntwurfA />} />
              <Route path="/entwurf-a" element={<EntwurfA />} />
              <Route path="/theme-preview" element={<StyleGuide />} />
              <Route path="/entwurf-b" element={<EntwurfB />} />
              <Route path="/entwurf-c" element={<EntwurfC />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/produkte" element={<Produkte />} />
              <Route path="/loesungen" element={<Loesungen />} />
              <Route path="/branchen" element={<Branchen />} />
              <Route path="/ressourcen" element={<Ressourcen />} />
              <Route path="/preise" element={<Preise />} />
              <Route
                path="/dashboard"
                element={
                  <Protected>
                    <Dashboard />
                  </Protected>
                }
              />
              <Route
                path="/install"
                element={
                  <Protected>
                    <Installer />
                  </Protected>
                }
              />
              <Route
                path="/activity"
                element={
                  <Protected>
                    <Activity />
                  </Protected>
                }
              />
              <Route
                path="/agent"
                element={
                  <Protected>
                    <AgentScript />
                  </Protected>
                }
              />
              <Route
                path="/tvmatch"
                element={
                  <Protected>
                    <TvMatch />
                  </Protected>
                }
              />
              <Route
                path="/inventory"
                element={
                  <Protected>
                    <Inventory />
                  </Protected>
                }
              />
              <Route
                path="/d/:ident"
                element={
                  <Protected>
                    <DeviceScan />
                  </Protected>
                }
              />
              <Route
                path="/locations"
                element={
                  <Protected>
                    <Locations />
                  </Protected>
                }
              />
              <Route
                path="/locations/:locationId"
                element={
                  <Protected>
                    <LocationDetail />
                  </Protected>
                }
              />
              <Route
                path="/tickets"
                element={
                  <Protected>
                    <Tickets />
                  </Protected>
                }
              />
              <Route
                path="/users"
                element={
                  <Protected>
                    <Users />
                  </Protected>
                }
              />
              <Route
                path="/products"
                element={
                  <Protected>
                    <Products />
                  </Protected>
                }
              />
              <Route
                path="/duplicates"
                element={
                  <Protected>
                    <Duplicates />
                  </Protected>
                }
              />
              <Route
                path="/reports"
                element={
                  <Protected>
                    <Reports />
                  </Protected>
                }
              />
              <Route
                path="/scanners"
                element={
                  <Protected>
                    <Scanners />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          </ConfirmProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
